import React, { useEffect, useMemo, useState } from 'react';
import { StepContainer, NavigationButtons, InfoBox } from '../index';
import { useWizard } from '../../wizard';
import { useLocation } from 'react-router-dom';
import { contentApi, type ContentPayload } from '../../services/contentApi';
import { normalizeFlowId } from '../../wizard/flowRegistry';

const GdprStep: React.FC = () => {
  const { goNext, goBack } = useWizard();
  const loc = useLocation();
  const flowSegment = useMemo(() => loc.pathname.split('/').filter(Boolean)[0] || null, [loc.pathname]);
  const flowId = useMemo(() => normalizeFlowId(flowSegment), [flowSegment]);
  const [content, setContent] = useState<ContentPayload>({});

  useEffect(() => {
    contentApi.get(flowId, 'gdpr', 'da').then(setContent).catch(() => setContent({}));
  }, [flowId]);

  return (
    <StepContainer title={content.title || 'Behandling af personoplysninger'}>
      <InfoBox type="info">
        {content.body && content.body.length > 0 ? (
          content.body.map((p, i) => <p key={i}>{p}</p>)
        ) : (
          <p>Dine oplysninger behandles i forbindelse med denne ansøgning i henhold til gældende regler. Læs mere på kommunens hjemmeside.</p>
        )}
        {content.bullets && (
          <ul>
            {content.bullets.map((b, i) => <li key={i}>{b}</li>)}
          </ul>
        )}
      </InfoBox>
      <NavigationButtons onBack={goBack} onNext={goNext} />
    </StepContainer>
  );
};

export default GdprStep;
